module.exports = __webpack_public_path__ + "img/intellect-scene-5.b4b048cd.png";